import React, { useId, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { useLang } from "../i18n";

export default function PartnerDirectoryInfo() {
  const { t } = useLang();
  const id = useId();
  const [open, setOpen] = useState(false);
  return <>
    <IconButton aria-label={t("s5.pdInfoTitle")} aria-haspopup="dialog" onClick={() => setOpen(true)}
      sx={{ minWidth: 44, minHeight: 44 }}>
      <InfoOutlined fontSize="small" />
    </IconButton>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" scroll="paper"
      aria-labelledby={`${id}-title`} PaperProps={{ className: "iio iio-review-dialog", sx: { m: 2, width: "calc(100% - 32px)", maxHeight: "calc(100% - 32px)" } }}>
      <DialogTitle id={`${id}-title`}>{t("s5.pdInfoTitle")}</DialogTitle>
      <DialogContent sx={{ lineHeight: 1.6, overflowWrap: "anywhere" }}>
        <Box component="ul" sx={{ m: 0, mb: 2, pl: 3, listStyle: "disc", "& li + li": { mt: 1.5 } }}>
          {["s5.pdInfoDirect", "s5.pdInfoAddr", "s5.pdInfoChain"].map(key => <li key={key}>{t(key)}</li>)}
        </Box>
        <Typography component="p" sx={{ lineHeight: "inherit" }}>{t("s5.pdInfoMiss")}</Typography>
      </DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)}>{t("common.close")}</Button></DialogActions>
    </Dialog>
  </>;
}
